import React from 'react'
import { BrowserRouter as Router } from 'react-router-dom'
import '@veneer/styles/typography/typography.css'
import { useShellRootContext } from 'src/contexts/ShellRoot'
import ErrorProvider from 'src/store/ErrorContext'
import ConfigProvider from 'src/store/ConfigContext'
import FeatureFlagProvider from 'src/store/FeatureFlagContext'
import UserProvider from 'src/store/UserContext'
import PrinterProvider from 'src/store/PrinterContext'
import ActivationProvider from 'src/store/ActivationContext'

import HPAllInProvider from '../../store/HPAllInContext'
import App from './App'

const AppWrapper = () => {
  // Use the ShellRootContext to access the shell features.
  const { t, interfaces = {} } = useShellRootContext?.() || {}
  const {
    v1: {
      analytics,
      navigation,
      store,
      localization,
      serviceRouting,
      monitoring,
      featureFlags,
      tenantHandlerInterface,
      app
    },
    v2: { authProvider }
  } = interfaces
  return (
    <Router>
      <ErrorProvider>
        <FeatureFlagProvider featureFlags={featureFlags}>
          <ConfigProvider
            authProvider={authProvider}
            navigation={navigation}
            analytics={analytics}
            store={store}
            app={app}
            localization={localization}
            serviceRouting={serviceRouting}
            monitoring={monitoring}
            t={t}
            tenantHandler={tenantHandlerInterface}
          >
            <UserProvider>
              <PrinterProvider>
                <ActivationProvider>
                  <HPAllInProvider>
                    <App />
                  </HPAllInProvider>
                </ActivationProvider>
              </PrinterProvider>
            </UserProvider>
          </ConfigProvider>
        </FeatureFlagProvider>
      </ErrorProvider>
    </Router>
  )
}

export default AppWrapper
